// extracted by mini-css-extract-plugin
module.exports = {"engagementSwitchContainer":"TableItem-moduleengagementSwitchContainerK8z","disabledToggle":"TableItem-moduledisabledToggle2_0"};